import { useContext, useState } from "react";
import styles from "./Mono.module.css";
import { SupportEmail } from "../../common/SupportFooter";
import { Header } from "../../common/Header";
import { AmountSection } from "../../common/AmountSection";
import { RoutingContext } from "../../../context/Router";
import { MobileWrapper } from "../../common/MobileWrapper";
import { Details } from "./Details";
import { BackToMethods } from "../../common/BackToMethods";
import { WalletPayProps } from "../Wallet";
import axios from "axios";
import { sendMessage } from "../../../context/utils";
import { ErrorAlertContext } from "../../../context/ErrorAlert";

export const MonoMethod = () => {
  const { email, currency, amount, merchantKey, payData } =
    useContext(RoutingContext);
  const { onShowAlert } = useContext(ErrorAlertContext);

  const [isLoading, setIsLoading] = useState(false);

  const onContinue = async (data?: WalletPayProps) => {
    let payload = {
      amount: amount,
      email: payData?.kit?.email,
      phone_number: data?.phone ? data.phone.replaceAll(/\s+/g, "") : "",
      country: "TZ",
      paymentType: payData?.kit?.paymentType,
      currency: payData?.currency,
      full_name: data?.fullname,
      // tx_ref: '12345678909876',
      tx_ref: payData?.kit?.tx_ref, // maybe use uuidv4
      sourceCurrency: payData?.sourceCurrency,
      sourceAmount: payData?.kit?.sourceAmount,
    };

    if (
      payData.kit.extra &&
      ["baepay", "baepayapp"].includes(payData.kit.extra)
    ) {
      // @ts-ignore
      payload.extra = "baepay";
      // @ts-ignore
      payload.baeEmail = payData?.kit?.baeEmail;
    }

    try {
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}pay/mono/initiate/payment`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": merchantKey,
        },
        data: payload,
      });
      const responseData = response.data;
      if (responseData.payment_link) {
        responseData.status = "pending";
        setTimeout(() => {
          sendMessage(responseData);
        }, 5000);
        window.location.replace(responseData.payment_link);
      } else if (responseData.error) {
        onShowAlert(responseData, responseData.error?.message);
      } else {
        // onShowAlert(responseData, "Payment failed please try again");
        onShowAlert(responseData, responseData?.message);
      }
      setIsLoading(false);
    } catch (error) {
      onShowAlert(error, "Payment failed please try again");
      setIsLoading(false);
    }
  };
  return (
    <MobileWrapper>
      <div className={styles.container}>
        <div className={styles.main}>
          <Header email={email} />
          <AmountSection amount={amount} currency={currency} />
          <div className={styles.body}>
            <Details
              onContinue={onContinue}
              defaultName={payData.kit.fullname}
              defaultPhone={payData.kit?.phone_number}
              isLoading={isLoading}
            />
          </div>
          <BackToMethods />
        </div>

        <SupportEmail />
      </div>
    </MobileWrapper>
  );
};
